import {createAction} from '@reduxjs/toolkit';
import {
  SET_BOOKINGS,
  SET_BOOKINGS_PAGINATION,
} from '@crema/types/actions/Booking.action';

export const SetBookings = createAction<any[]>(SET_BOOKINGS);
export const SetBookingsPagination = createAction<{
  count: number;
  pages: number;
}>(SET_BOOKINGS_PAGINATION);
